import React, { Component } from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import { Heading, Modal } from '@/components'

import './AbandonExamModal.scss'

const AbandonExamModalMessages = defineMessages({
  body: {
    defaultMessage:
      'Are you sure you want to abandon this exam? Your progress will be submitted with your current score.',
    description: 'Body text for abandon exam confirmation modal.',
    id: 'AbandonExamModal.body',
  },
  cancel: {
    defaultMessage: 'Cancel',
    description: 'Cancel button text.',
    id: 'AbandonExamModal.cancel',
  },
  confirm: {
    defaultMessage: 'Abandon Exam',
    description: 'Confirm button text.',
    id: 'AbandonExamModal.confirm',
  },
  title: {
    defaultMessage: 'Abandon Exam?',
    description: 'Title for abandon exam confirmation modal.',
    id: 'AbandonExamModal.title',
  },
})

@injectIntl
class AbandonExamModal extends Component {
  onClose = () => {
    const { onClose } = this.props
    if (onClose) {
      onClose()
    }
  }

  onConfirm = () => {
    const { onConfirm } = this.props
    if (onConfirm) {
      onConfirm()
    }
  }

  render() {
    const { intl, isOpen, isLoading } = this.props
    const { formatMessage } = intl
    return (
      <Modal
        className="AbandonExamModal"
        contentLabel="Abandon Exam Modal"
        isCard
        isOpen={isOpen}
        scrollTop
      >
        <Modal.Header>
          <Heading>{formatMessage(AbandonExamModalMessages.title)}</Heading>
        </Modal.Header>
        <Modal.Body>
          <p>{formatMessage(AbandonExamModalMessages.body)}</p>
        </Modal.Body>
        <Modal.Footer>
          <Modal.Button isSecondary onClick={this.onClose}>
            {formatMessage(AbandonExamModalMessages.cancel)}
          </Modal.Button>
          <Modal.Button isDanger isLoading={isLoading} onClick={this.onConfirm}>
            {formatMessage(AbandonExamModalMessages.confirm)}
          </Modal.Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default AbandonExamModal
